import ViewAllStandardModal from "./ViewAllStandardModal";

export default ViewAllStandardModal;
